import MapsComponent from './Maps'
import LoadMapComponent from './LoadMap'
import AutocompleteComponent from './Autocomplete'

export const Maps = MapsComponent
export const LoadMap = LoadMapComponent
export const Autocomplete = AutocompleteComponent


// WEBPACK FOOTER //
// ./src/components/third-party/GoogleMap/index.js